import { createActionTypesMap } from '../utils/helpers';

export const superadmin = createActionTypesMap('/api/v1/superadmin', [
  '/tenants',
  '/contacts',
  '/integration/models',
  '/ai-agents',
  '/system/logs',
  '/paginated-users',
  '/users/reset-password',
  '/tenant/run-migrations',
  '/tenant/run-seeds',
  '/tenant/create-users-from-sellers',
  '/job-histories',
  '/tenant-roles',
  '/smartsell/app-versions',
  '/tenant/access-log',
  '/access-control',
  '/access-control-metrics',
  '/access-control-tenants-metrics',
  '/reports-for-superadmin',
]);

export const auth = createActionTypesMap('/api/v1/auth', [
  '/login',
  '/logout',
  '/refresh',
  '/user',
  '/send-email-to-reset-password',
  '/reset-password',
  '/external/login',
]);

export const common = createActionTypesMap('/api/v1/common', [
  '/visit_routines',
  '/visit_scheduled/generate_from_visit_routines',
  '/visit_routines/sellers_summary',
  '/visit_routines/reconcile',
  '/visit_scheduled',
  '/visit_motives',
  '/forms',
  '/audience',
  '/audience/automated',
  '/audience/users',
  '/audience/remove-participants',
  '/messages',
  '/sandbox/test-code',
  '/goals',
  '/form-question',
  '/visit_history',
  '/marketing-research',
  '/marketing-research-returns',
  '/branch',
  '/tenant-manager',
  '/tenant-supervisor',
  '/smartsell-environments',
]);

// export const users = createActionTypesMap('/api/v1/system', ['/users']);
export const system = createActionTypesMap('/api/v1/system', [
  '/roles',
  '/users',
  '/ai-agents/active',
  '/api-keys',
  '/users/reset-password',
  '/permissions',
  '/tenants',
  '/tasks',
  '/tasks/done',
  '/temp-files',
  '/temp-files/download',
  '/temp-files/temporary-url',
  '/temp-files/upload',
  '/smartbanners',
  '/parameters',
  '/sellers-parameters',
  '/new-seller-parameter-by-reference',
  '/motives',
  '/motives-by-actions',
  '/motives-by-actions/delete',
  '/actions',
  '/communication-by-action-and-order',
  '/communication-by-action-and-order/delete',
  '/communication-by-action-and-order/motives',
  '/communication-group',
  '/communication-automation',
  '/edi-layout',
  '/edi-layout-parameters-required',
  '/edi-customers',
  '/edi-add-customers',
  '/edi-remove-customers',
  '/supervision-of-sellers/get-paginated',
  '/supervision-of-sellers/add-sellers',
  '/supervision-of-sellers/remove-sellers',
  '/smartsell/sync/lock',
  '/smartsell/app-version/link-audience',
  '/smartsell/app-version/versions',
  '/edi-payment-condition/upsert',
  '/edi-payment-condition/edit',
  '/edi-payment-condition/delete-many',
  '/edi-payment-condition/paginated',
  '/auth-settings',
  '/auth-settings/tenant_id',
  '/access-control/blocks',
  '/job-histories',
  '/smartsell/db-tables',
  '/smartsell/db-table-columns',
]);

export const databaseManagement = createActionTypesMap('/api/v1/database-management', [
  '/available-tables',
  '/update-from-file',
  '/export-as-file',
  '/download-latest-export',
  '/db-map',
  '/db-map/show',
  '/table-extensions',
  '/table-extensions/options',
]);

export const logs = createActionTypesMap('/api/v1/system/logs', [
  '/communication',
  '/order-change',
]);

export const integration = createActionTypesMap('/api/v1/integration', [
  '/log',
  '/config',
  '/models',
  '/fastmanager/urls',
]);

export const customers = createActionTypesMap('/api/v1/customers', [
  '',
  '/',
  '/export',
  '/import',
  '/mix/grouped',
  '/mix/update-or-insert',
  '/mix/remove',
  '/new-customer',
  '/new-customer-log-transaction'
]);

export const customersPosition = createActionTypesMap('/api/v1/customers-position', ['']);

export const customerBills = createActionTypesMap('/api/v1/customers/bills', [
  '/export',
  '/import',
]);

export const customerLimit = createActionTypesMap('/api/v1/customers/limits', [
  '/export',
  '/import',
]);

export const customerChannel = createActionTypesMap('/api/v1/customers/channels', [
  '/export',
  '/import',
]);

export const orderOrigin = createActionTypesMap('/api/v1/order-origins', ['', '/']);

export const ordersTypes = createActionTypesMap('/api/v1/orders/types', ['', '/']);

export const dashboard = createActionTypesMap('/api/v1/dashboard', [
  '/etl/sales-consolidated',
  '/etl/sellers-ranking',
  '/etl/products-orders',
  '/etl/customers-orders',
  '/etl/goals',
  '/settings',
  '/log',
  '/marketing-research-metrics',
  '/visit-metrics',
]);

export const sellers = createActionTypesMap('/api/v1/sellers', ['', '/', '/goals-many']);

export const templates = createActionTypesMap('/api/v1', [
  '/templates',
  '/template-parameters',
  '/template-parameters/paginated',
  '/template-parameters/ediPaginated',
  '/template-parameters/get-by-name',
]);

export const email = createActionTypesMap('/api/v1/email', [
  '/send/communication-automation',
  '/logs',
  '/smtp/config',
  '/send',
  '/tenant-resend',
  '/check-if-use-email-sending',
]);

export const reports = createActionTypesMap('/api/v1/reports', [
  '/functions',
  '/jasper/bases',
  '/jasper/get-jrxml-file',
]);

export const advantageClub = createActionTypesMap('/api/v1/advantage-club', ['']);
export const advantageClubHistory = createActionTypesMap('/api/v1/advantage-club-history', ['']);
export const advantageClubBalance = createActionTypesMap('/api/v1/advantage-club-balance', ['']);
export const advantageClubWithdrawManual = createActionTypesMap(
  '/api/v1/advantage-club-withdraw-manual',
  [''],
);
export const clubPointValueInBrCurrency = createActionTypesMap(
  '/api/v1/club-point-Value-in-br-currency',
  [''],
);

export const product = createActionTypesMap(
  '/api/v1/products',
  [
    '/p',
    '/catalog',
    '/images',
    '/seller',
    '/seller/delete-many',
    '/pricetables-codes',
  ]
);

export const tenantRoles = createActionTypesMap('/api/v1/superadmin/tenant-roles', ['']);

export const tenantCustomLibs = createActionTypesMap('/api/v1/tenant-custom-libs', [
  '/libs',
  '/versions',
  '/last-version-by-seller',
  '/version-download',
]);

export const importer = createActionTypesMap('/api/v1/importer', ['', '/logs']);

export const exporter = createActionTypesMap('/api/v1/exporter', [
  '',
  '/logs',
  '/get-available-tables',
]);

export const orders = createActionTypesMap('/api/v1/orders', [
  '',
  '/unified',
  '/payment-condition/api',
  '/payment-method/api',
  '/billing-units',
  '/types',
  '/fractional-items',
  '/approval-groups',
  '/pendencies',
  '/pendencies/grouped',
]);

export const orderStatus = createActionTypesMap('/api/v1/orders/order-status', [
  '',
  '/',
]);

export const mobileOrderStatus = createActionTypesMap('/api/v1/orders/status-pedido', [
  '',
  '/',
]);

export const datasync = createActionTypesMap('/api/v1/datasync', [
  '',
  '/',
  '/types/paginated',
  '/logs/paginated',
]);
